import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap-5';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuildoutLogo } from 'helpers/custom_fontawesome_icons';
import { faMask } from '@fortawesome/pro-solid-svg-icons';

import {
  fetchRemainingUnlocks,
  unlockPropertyOwners
} from 'bundles/connect/helpers/connect_api';

export default function ContactsUnlockPanel({ id, onUnlock }) {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [remainingUnlocks, setRemainingUnlocks] = useState(0);

  const getRemainingUnlocks = () => {
    fetchRemainingUnlocks()
      .then(setRemainingUnlocks)
      .catch(() => setRemainingUnlocks(0))
      .finally(() => setLoading(false));
  };

  const handleUnlockOwners = () => {
    setSaving(true);
    
    unlockPropertyOwners(id)
      .then(onUnlock)
      .catch(console.warn)
      .finally(() => setSaving(false));
  };

  useEffect(() => {
    getRemainingUnlocks();
  }, []);

  if (loading) {
    return (
      <div className="text-center py-4">
        <FontAwesomeIcon
          beatFade
          className="text-primary"
          icon={faBuildoutLogo}
          size="3x"
        />
      </div>
    );
  }

  if (remainingUnlocks === 0) {
    return (
      <div className="text-center">
        <p className="text-danger">
          You are not authorized to obtain information from owners. You've
          exhausted your credits this month.
        </p>
      </div>
    );
  }

  return (
    <div className="position-absolute d-flex align-items-center justify-content-center" style={{ inset: 0, backgroundColor: 'rgba(255,255,255,0.6)', zIndex: 999, backdropFilter: `blur(2.5px)` }}>
      <div className="py-4 px-3 gap-2 text-center card shadow">
        <div>
          <FontAwesomeIcon
            className="text-accent"
            icon={faMask}
            size="2x"
          />
        </div>
        <div className="py-2 gap-4">
          <h3>Unmask contacts</h3>
          <div className="py-4 gap-2 bg-light">
            <h3 className="fw-semi-light">{remainingUnlocks}</h3>
            <p>Remaining</p>
          </div>
        </div>
        <div>
          <p>Would you like to find out contact information?</p>
        </div>
        <Button disabled={saving} variant="secondary" onClick={handleUnlockOwners}>
          Unmask this property
        </Button>
      </div>
    </div>
  );
}

ContactsUnlockPanel.propTypes = {
  id: PropTypes.number.isRequired,
  onUnlock: PropTypes.func.isRequired,
};
